import api from "../api";

export interface ResponseGenerica<T> {
  datos: T[],
  error?: string
}
export interface IfetchPuntoServicio {
  ps_nombre: string;
  ps_codigo: string;
  estado: number;
  objeto: number;
  id: number;
  objetivo: IFiscalizacion;
}
export interface IfetchObjetivos {
  cargo: string;
  datos?: IObjetivos[];
  fecha: string;
  usuario: string;
  mensaje?: string;
}
export interface IObjetivos {
  empresa_id: any;
  id: number;
  objetivos: string;
}
export interface IfetchObjetivosItems {
  datos?: IObjetivosItems[];
  mensaje?: string;
}
export interface IObjetivosItems {
  id: number;
  codigo: string;
  opcion: string;
}
export interface IfetchPersonas {
  id: number;
  nombre: string;
  legajo: string;
  total_asignado: string; 
}
export interface IResponseFiscalizacion {
  mensaje?: string;
  datos?:{
    fiscalizacion_id: number;
  }
}
export interface IResponseObtenerFiscalizacion {
  mensaje?: string;
  datos?: IFiscalizacion;
}
export interface IFiscalizacion {
  fis_id: number | undefined;
  ps_id: number;
  ps_nombre: string;
  ps_objeto: string;
  ob_objetivo?: number;
  ob_id?: number;
  opciones: IItemsFiscalizacion[];
}
export interface IItemsFiscalizacion {
  puntoDeservicio: number;
  id: number;
  opcion: string;
  codigo: string;
}

export interface IComentarioFiscaliacion {
  comentario?: string;
  codigo?: string;
  fis_id?: number;
  id?: number;
  opcion?: string
}
export interface IOpinionClienteFiscalizacion {
  id?: number;
  nombre_contacto: string;
  opinion_cliente: string;
}
export interface IPostComentarioFiscalizacion {
  comentario_id?: number;
  fis_id?: number;
  comentario?: string;
  contacto?: string;
  cod_id?: string;
}
export interface IResponsePostComentario {
  exito: boolean;
  info: string;
}


export interface ICalificaciones {
  id: number;
  nombre: string;
}
export interface IMedidasCorrectivas {
  descripcion: string;
  id: number;
  tipo_id: number;
}
export interface IDepositoResponse {
  calificacion_id: number | null;
  calificacion: string | null;
  medida_correctiva_id: number | null;
  medida_correctiva: string | null;
  plazo: string | null;
}
export interface IPostDeposito {
  calificar_id: number;
  fiscalizacion_id: number;
  medidas_correctivas_id: number | null;
  plazo: string | null;
}


export interface IProductos {
  porcentaje: any;
  cantidad: number;
  CantidadStock:    number;
  CantidadSugerida: number;
  CodItem:          string;
  Cont:             number;
  DescripcionItem:  string;
  PrecioTotal:      string;
  PrecioUnitario:   string;
  fecha:            string;
  origen:           string;
}

export interface ILimpiezaProfunda {
  cant_horas:  string;
  codigo:      string;
  estado:      string;
  fecha:       string;
  frecuencia:  string;
  id:          number;
  lp_emsys?:   number;
  origen:      string;
  tipo_lavado: string;
}

export interface IListarLimpiezaProfunda {
  estado: string;
  id: number;
}
export interface ILimpiezaGeneral {
  id?: number;
  fiscalizacion?: number;
  calificacion: string;
  comentario: string;
  acciones_correctivas: string;
  fecha?: string;
}
export interface IResponsePostProductos {
  exito: boolean;
  info?: string;
}


const API_URL_PUNTO_SERVICIO = `fiscalizacion/puntos_servicio`;
const API_URL_OBJETIVOS = `fiscalizacion/objetivos`;
const API_URL_OBJETIVOSPORID = `fiscalizacion/opciones`;
const API_URL_PERSONAS = `fiscalizacion/operarios_asignados`;
const API_URL_INICIAR_FISCALIZACION = `fiscalizacion/nueva_fiscalizacion`;
const API_URL_OBTENER_FIZCALIZACION = `fiscalizacion/obtener_fiscalizacion`;
const API_URL_FINALIZAR_FISCALIZACION = `fiscalizacion/cerrar_fiscalizacion`;
const API_URL_LISTAR_MEDIDAS = `fiscalizacion/medidas_correctivas`;
const API_URL_GUARDAR_MEDIDAS_IMAGEN = `/fiscalizacion/personal/imagen`;
const API_URL_GUARDAR_MEDIDAS_PROCEDIMIENTOS = `/fiscalizacion/personal/procedimientos`;
const API_URL_GUARDAR_MEDIDAS_RUTINAS = `/fiscalizacion/personal/rutina`;
const API_URL_PRODUCTOS = `/fiscalizacion/productos`;
const API_URL_PRODUCTOS_POST = `/fiscalizacion/productos/actualizar_producto`;
const API_URL_PRODUCTOS_DELETE = `/fiscalizacion/productos/eliminar_producto`;
// Catálogo de BC (lista EM): se reutiliza el endpoint del módulo de pedidos para no
// duplicar la consulta a DWH_ERP_BC
const API_URL_CATALOGO_PRODUCTOS = `/pedido-productos/obtener-item-producto`;
const API_URL_LIMPIEZA_PROFUNDA = `/fiscalizacion/lavado_profundo`;
const API_URL_LIMPIEZA_PROFUNDA_LISTAR = `/fiscalizacion/lavado_profundo/estados`;
const API_URL_LIMPIEZA_PROFUNDA_POST = `/fiscalizacion/lavado_profundo/cambiar_estado`;
const API_URL_LIMPIEZA_GENERAL = `/fiscalizacion/limpieza_general`;


const areasFiscMap = [
	{nombre: "Personal", ico: "personal", url: "fiscalizarpersonal"},
	{nombre: "Deposito", ico: "deposito", url: "fiscalizardeposito"},
	{nombre: "Maquinas", ico: "maquinas", url: "fiscalizarmaquina"},
	{nombre: "Calificar Nivel de Limpieza General", ico: "limpieza", url: "fiscalizarlimpieza"},
	{nombre: "Opinion del Cliente", ico: "opinion", url: "fiscalizaropinion"},
	{nombre: "Stock de Productos", ico: "stock", url: "fiscalizarstock"},
];
const objetivoIconosMap = {
    "Reclamo": ["Personal", "Deposito", "Maquinas", "Calificar Nivel de Limpieza General", "Opinion del Cliente", "Stock de Productos"],
    "Reunión con el cliente": ["Opinion del Cliente"],
    "Acompañamiento por limpieza profunda": ["Personal", "Calificar Nivel de Limpieza General", "Stock de Productos"],
    "Fiscalización de rutina": ["Personal", "Deposito", "Maquinas", "Calificar Nivel de Limpieza General", "Opinion del Cliente", "Stock de Productos"],
    "Incorporación de nuevo personal": ["Personal"],
    "Baja encuesta de satisfacción": ["Personal", "Deposito", "Calificar Nivel de Limpieza General", "Opinion del Cliente"]
  };

export const obtenerAreasPorObjetivo = (objetivo) => {
    const areasObjetivo = objetivoIconosMap[objetivo] || [];
    return areasObjetivo.map(area => 
      areasFiscMap.find(a => a.nombre === area) || { nombre: area, ico: '', url: '' }
    );
  };
  

  export const fetchPuntoServicio = async (ps_nombre:string): Promise<ResponseGenerica<IfetchPuntoServicio>> => {
    try {
      const response = await api.get(`${API_URL_PUNTO_SERVICIO}?ps_nombre=${ps_nombre}`)

        const data: { datos: IfetchPuntoServicio[]; error?: string } = await response.data;
      
        if (data.error || response.status >= 300 || response.status <= 199 || !data.datos) {
            return {
                datos: [],
                error: data.error ?? 'Ocurrió un error al obtener los puntos de servicio.'
            };
      }

        return data;

    } catch (error) {
        console.error('Error:', error);
        return {
            datos: [],
            error: "Ocurrió un error al obtener los puntos de servicio."
        };
    }
}

export const fetchObjetivos = async (): Promise<ResponseGenerica<IObjetivos>> => {
    try {
      const response = await api.get(API_URL_OBJETIVOS);
  
      const data: IfetchObjetivos = await response.data;
      
      if (!data.datos || response.status >= 300 || response.status <= 199) {
        return { 
          datos:[],
          error: data.mensaje ?? 'Ocurrió un error al obtener los objetivos' };
      }
      
      return { datos: data.datos };

    } catch (error) {
      console.error('Error:', error);
      return {datos: [], error: "Ocurrió un error inesperado al obtener los objetivos"};
    }
}

export const fetchObjetivosPorItemId = async (itemId: number): Promise<ResponseGenerica<IObjetivosItems>> => {
  try {
    const response = await api.get(`${API_URL_OBJETIVOSPORID}/${itemId}`);

    const data: IfetchObjetivosItems = await response.data;
    if (!data.datos || response.status >= 300 || response.status <= 199) {
      return { 
        datos:[],
        error: data.mensaje ?? 'Ocurrió un error al obtener los items del objetivo' };
    }
    
    return { datos: data.datos };

  } catch (error) {
    console.error('Error:', error);
    return {datos: [], error: "Ocurrió un error inesperado al obtener los items del objetivo"};
  }
}


export const fetchPersonas = async (puntoservicio_id:number): Promise<ResponseGenerica<IfetchPersonas>> => {
  try {

      const response = await api.get(`${API_URL_PERSONAS}/${puntoservicio_id}`);
  
      const data: { datos: IfetchPersonas[]; error?: string } = await response.data;
      
      if (data.error || response.status >= 300 || response.status <= 199 || !data.datos) {
          return {
              datos: [],
              error: data.error ?? 'Error al obtener las personas asignadas. Por favor, intente más tarde.'
          };
      }

      return data;

  } catch (error) {
      console.error('Error al obtener las personas asignadas:', error);
      return {
          datos: [],
          error: 'Error inesperado al obtener las personas asignadas. Por favor, intente más tarde.'
      };
  }
};

export const fetchIniciarFiscalizacion = async (ps_id:number, objetivo:number ): Promise<{fiscalizacion_id:number, error?:string}> => {
  
  try {
      const response = await api.post(API_URL_INICIAR_FISCALIZACION, {
        ps_id,
        objetivo,
      });

      const data:IResponseFiscalizacion = await response.data;
      
      if (!data.datos?.fiscalizacion_id || response.status >= 300 || response.status <= 199) {
        return {
          fiscalizacion_id: data.datos?.fiscalizacion_id ?? 0,
          error: data.mensaje ?? 'Error al iniciar la fiscalización. Por favor, intente más tarde.'
        };
      }

      return {
        fiscalizacion_id: data.datos.fiscalizacion_id
      };

  } catch (error) {
      console.error('Error al iniciar la fiscalización:', error);
      return {
        fiscalizacion_id: 0,
        error: 'Error inesperado al iniciar la fiscalización. Por favor, intente más tarde.'
      };
  }
}

export const fetchObtenerFiscalizacion = async (puntoservicio_id:number): Promise<{fiscalizacion: IFiscalizacion, error?: string}> => {
  try {
      const response = await api.get(`${API_URL_OBTENER_FIZCALIZACION}/${puntoservicio_id}`);

      const data: IResponseObtenerFiscalizacion = await response.data;

      if (!data.datos || response.status >= 300 || response.status <= 199) {
          return {
              fiscalizacion: {
                fis_id: 0, opciones: [],
                ps_id: 0,
                ps_nombre: "",
                ps_objeto: "",
              },
              error: data.mensaje ?? 'Error al obtener la fiscalización. Por favor, intente más tarde.'
          };
      }

      return {
        fiscalizacion: data?.datos
      };

  } catch (error) {
      console.error('Error al obtener la fiscalización:', error);
      return {
          fiscalizacion: {
            fis_id: 0, opciones: [],
            ps_id: 0,
            ps_nombre: "",
            ps_objeto: ""
          },
          error: 'Error inesperado al obtener la fiscalización. Por favor, intente más tarde.'
      };
  }
}
export const fetchOpinionCliente = async (fiscalizacion_id: number): Promise<{ datos: IOpinionClienteFiscalizacion, error?: string }> => {
  try {
    const response = await api.get(`fiscalizacion/opinion_cliente/${fiscalizacion_id}`);
    const data = response.data;

    if (!data.datos || response.status < 200 || response.status >= 300) {
      return {
        datos: {
          id: undefined,
          nombre_contacto: '',
          opinion_cliente: '',
        },
        error: data.info || 'Error desconocido al obtener los datos',
      };
    }

    return {
      datos: {
        id: data.datos.id,
        nombre_contacto: data.datos.contacto,
        opinion_cliente: data.datos.comentario,
      },
    };
  } catch (error: any) {
    console.error('Error al obtener el comentario de la fiscalización:', error);
    return {
      datos: {
        id: undefined,
        nombre_contacto: '',
        opinion_cliente: '',
      },
      error: error.message || 'Error inesperado al obtener la opinión. Por favor, intente más tarde.',
    };
  }
};
export const getComentario = async (fis_id: number, cod_id: string): Promise<{ datos: IComentarioFiscaliacion, error?: string }> => {
  try {
    const response = await api.get(`/fiscalizacion/obtener-comentario/${fis_id}/${cod_id}`);
    const data = response.data;
    if (!data.datos || response.status < 200 || response.status >= 300) {
      return data;
    }

    return data
  } catch (error: any) {
    console.error('Error al obtener el comentario de la fiscalización:', error);
    return error
  }
};


export const postOpinionClienteFiscalizacion = async (comentarioData: IPostComentarioFiscalizacion, id): Promise<IResponsePostComentario> => {
  try {
    const response = await api.post(`fiscalizacion/opinion_cliente/${id}`, comentarioData);

    const data: IResponsePostComentario = await response.data;
   
    return {
      ...data,
      exito: data.exito !== undefined ? data.exito : true,
    } as IResponsePostComentario;
  } catch (error) {
    console.error('Error en la solicitud POST del comentario:', error);
    return {
      exito: false,
      info: 'Error inesperado al enviar el comentario. Por favor, intente más tarde.'
    };
  }
}
export const postComentarioFiscalizacion = async (comentarioData: IPostComentarioFiscalizacion): Promise<IResponsePostComentario> => {
  try {
    const response = await api.post(`fiscalizacion/crear-comentario`, comentarioData);

    const data: IResponsePostComentario = await response.data;
   
    return data;

  } catch (error) {
    console.error('Error en la solicitud POST del comentario:', error);
    return {
      exito: false,
      info: 'Error inesperado al enviar el comentario. Por favor, intente más tarde.'
    };
  }
}

export const fetchFinalizarFiscalizacion = async (fiscalizacionId: number) => {
  try {
    const response = await api.post(`${API_URL_FINALIZAR_FISCALIZACION}/${fiscalizacionId}`);

    if (response.data && (response.data.datos || response.data.info)) {
      return {
        datos: response.data.datos ?? response.data.info
      };
    } else {
      return {
        datos: [],
        error: response.data.error || "No se pudo finalizar la fiscalización"
      };
    }
  } catch (error: any) {
    console.error('Error en fetchFinalizarFiscalizacion:', error);
    return {
      datos: [],
      error: error?.response?.data?.error || "Error al finalizar la fiscalización"
    };
  }
};

export const fetchListarMedidas = async () => {
  try {
    const response = await api.get(`${API_URL_LISTAR_MEDIDAS}`);

    if (response.data && response.data.datos) {
      return {
        datos: response.data.datos
      };
    } else {
      return {
        datos: [],
        error: response.data.error || "No se encontró información de las medidas"
      };
    }
  } catch (error) {
    console.error('Error en fetchDeposito:', error);
    return {
      datos: [],
      error: "Error al obtener información de las medidas"
    };
  }
}

export const fetchGuardarMedidasImagen = async (
  fiscalizacionId: number,
  legajo: number,
  datos?: any
): Promise<IResponsePostComentario> => {
  const url = `${API_URL_GUARDAR_MEDIDAS_IMAGEN}/${fiscalizacionId}/${legajo}`;

  try {
    const response = datos
      ? await api.post(url, datos) // POST si se envían datos
      : await api.get(url);       // GET si no se envían datos

    return response.data;
  } catch (error: any) {
    console.error(error.response?.data?.error || error.message);
    return {
      exito: false,
      info: error.response?.data?.error || "Error desconocido",
    };
  }
};

export const fetchMedidasProcedimiento = async (
  fiscalizacionId: number,
  legajo: number,
  datos?: any
): Promise<IResponsePostComentario> => {
  const url = `${API_URL_GUARDAR_MEDIDAS_PROCEDIMIENTOS}/${fiscalizacionId}/${legajo}`;

  try {
    const response = datos
      ? await api.post(url, datos)
      : await api.get(url);

    return response.data;
  } catch (error: any) {
    console.error(error.response?.data?.error || error.message);
    return {
      exito: false,
      info: error.response?.data?.error || "Error desconocido",
    };
  }
};

export const fetchMedidasRutinas = async (
  fiscalizacionId: number,
  legajo: number,
  datos?: any
): Promise<IResponsePostComentario> => {
  const url = `${API_URL_GUARDAR_MEDIDAS_RUTINAS}/${fiscalizacionId}/${legajo}`;

  try {
    const response = datos
      ? await api.post(url, datos)
      : await api.get(url);

    return response.data;
  } catch (error: any) {
    console.error(error.response?.data?.error || error.message);
    return {
      exito: false,
      info: error.response?.data?.error || "Error desconocido",
    };
  }
};


export const fetchProductos = async(fiscalizacion_id: number): Promise<ResponseGenerica<IProductos[]>> => {
  try {
    const response = await api.get(`${API_URL_PRODUCTOS}/${fiscalizacion_id}`);

    if (response.data && response.data.datos) {
      return {
        datos: response.data.datos
      };
    } else {
      return {
        datos: [],
        error: response.data.error || "No se encontró información de los productos"
      };
    }
  } catch (error) {
    console.error('Error en fetchDeposito:', error);
    return {
      datos: [],
      error: "Error al obtener información de los productos"
    };
  }
}

// Ítem del catálogo de Business Central (lista de precios EM). Es el mismo catálogo
// que usa el pedido de productos, para poder fiscalizar un ítem que todavía no tiene
// historial en el PS.
export interface ICatalogoProducto {
  prod_nombre: string;
  prod_descripcion: string;
  precio_unitario: number;
}

export const fetchCatalogoProductos = async (): Promise<ICatalogoProducto[]> => {
  try {
    const response = await api.get(API_URL_CATALOGO_PRODUCTOS);

    return (response.data?.datos as ICatalogoProducto[]) ?? [];
  } catch (error) {
    console.error('Error en fetchCatalogoProductos:', error);

    return [];
  }
}

export const fetchEliminarProducto = async (
  fiscalizacionId: number,
  codItem: string
): Promise<IResponsePostProductos> => {
  try {
    const response = await api.delete(`${API_URL_PRODUCTOS_DELETE}/${fiscalizacionId}`, {
      data: { CodItem: codItem },
    });

    if (response.data?.info) {
      return { exito: true, info: response.data.info };
    }

    return {
      exito: false,
      info: response.data?.error ?? 'No se pudo eliminar el producto',
    };
  } catch (error: any) {
    console.error('Error en fetchEliminarProducto:', error);

    return {
      exito: false,
      info: error?.response?.data?.error ?? 'Error inesperado al eliminar el producto',
    };
  }
}

export const fetchProductosPost = async ( fiscalizacionId: number, datos): Promise<IResponsePostProductos> => {
  try {
    const response = await api.post(`${API_URL_PRODUCTOS_POST}/${fiscalizacionId}`, datos);
    if (response.data && response.data.exito) {
        return response.data;
    } else {
        return {
            exito: true,
            info: response.data.info ?? "Error al procesar información de las máquinas"
        };
    }
} catch (error) {
    console.error('Error en postMaquinas:', error);
    return {
        exito: false,
        info: "Error inesperado al procesar información de las máquinas"
    };
}
};


export const fetchLimpiezaProfunda= async(fiscalizacion_id: number): Promise<ResponseGenerica<ILimpiezaProfunda[]>> => {
  try {
    const response = await api.get(`${API_URL_LIMPIEZA_PROFUNDA}/${fiscalizacion_id}`);
   
    if (response.data && response.data.datos) {
      return {
        datos: response.data.datos
      };
    } else {
      return {
        datos: [],
        error: response.data.error || "No se encontró información de los productos"
      };
    }
  } catch (error) {
    console.error('Error en fetchDeposito:', error);
    return {
      datos: [],
      error: "Error al obtener información de los productos"
    };
  }
}

//listar estados

export const fetchListarLimpiezaProfunda = async (): Promise<ResponseGenerica<IListarLimpiezaProfunda[]>> => {
  try {
    const response = await api.get(`${API_URL_LIMPIEZA_PROFUNDA_LISTAR}`);
    if (response.data && response.data.datos) {
      return {
        datos: response.data.datos
      };
    } else {
      return {
        datos: [],
        error: response.data.error || "No se encontró información de los productos"
      };
    }
  } catch (error) {
    console.error('Error en fetchDeposito:', error);
    return {
      datos: [],
      error: "Error al obtener información de los productos"
    };
  }
}

export const fetchLimpiezaProfundaPost = async (datos) => {
  try {
  const response = await api.post(`${API_URL_LIMPIEZA_PROFUNDA_POST}`, datos);
 if (response.status === 200) {
    return {
      exito: true,
      info: response.data.info
    }
  }
  else{
    return {
      exito: false,
      info: response.data.error || "No se pudo guardar las LP"
    };
  }
}catch (error) {
  console.error('Error en fetchLP-POST:', error);
  return {
    exito: false,
    info: "Error al guardar las LP"
  };
}
}

export const fetchLimpiezaGeneral = async (fiscalizacionId: number): Promise<{ datos: ILimpiezaGeneral; comentario_requerido: boolean; error?: string }> => {
  try {
    const response = await api.get(`${API_URL_LIMPIEZA_GENERAL}/${fiscalizacionId}`);
    const data = response.data;

    return {
      datos: {
        id: data?.datos?.id,
        fiscalizacion: data?.datos?.fiscalizacion,
        calificacion: data?.datos?.calificacion || '',
        comentario: data?.datos?.comentario || '',
        acciones_correctivas: data?.datos?.acciones_correctivas || '',
        fecha: data?.datos?.fecha || '',
      },
      comentario_requerido: Boolean(data?.meta?.comentario_requerido),
      error: response.status >= 300 ? (data?.error || 'No se pudo obtener la calificación general de limpieza') : undefined,
    };
  } catch (error: any) {
    console.error('Error en fetchLimpiezaGeneral:', error);
    return {
      datos: {
        calificacion: '',
        comentario: '',
        acciones_correctivas: '',
      },
      comentario_requerido: false,
      error: error?.response?.data?.error || 'Error al obtener la calificación general de limpieza',
    };
  }
}

export const postLimpiezaGeneral = async (fiscalizacionId: number, datos: ILimpiezaGeneral): Promise<IResponsePostComentario> => {
  try {
    const response = await api.post(`${API_URL_LIMPIEZA_GENERAL}/${fiscalizacionId}`, datos);
    return {
      exito: true,
      info: response.data?.info || 'Calificación guardada correctamente',
    };
  } catch (error: any) {
    console.error('Error en postLimpiezaGeneral:', error);
    return {
      exito: false,
      info: error?.response?.data?.error || 'Error al guardar la calificación general de limpieza',
    };
  }
}

// ---------------------------------------------------------------------------
// Historial: ultimas 5 fiscalizaciones finalizadas del PS (solo lectura)
// ---------------------------------------------------------------------------
const API_URL_HISTORIAL = `fiscalizacion/historial`;

export interface IHistorialFiscalizacion {
  fis_id: number;
  ps_id: number;
  ps_nombre: string;
  fecha: string;
  objetivo: string;
  fiscal: string;
  fiscal_nombre: string;
  limpieza_calificacion: string | null;
}

export interface ICalificacionHistorial {
  calificacion: string | null;
  medida_correctiva: string | null;
  plazo_implementacion: string | null;
}

export interface IOperarioHistorial {
  legajo: string;
  nombre: string;
  imagen: ICalificacionHistorial | null;
  rutina: ICalificacionHistorial | null;
  procedimiento: ICalificacionHistorial | null;
}

export interface IDetalleHistorialFiscalizacion {
  fis_id: number;
  ps_id: number;
  ps_nombre: string;
  contacto_nombre: string | null;
  fecha: string;
  objetivos: string;
  fiscal_nombre: string;
  personal: IOperarioHistorial[];
  deposito: Partial<ICalificacionHistorial>;
  maquinas: {
    id: number;
    maquina_codigo: string;
    maquina_descripcion: string;
    calificacion: string | null;
    medida_correctiva: string | null;
    descripcion_problema: string | null;
  }[];
  limpieza_general: Partial<ILimpiezaGeneral>;
  lavado_profundo: {
    id: number;
    frecuencia: string | null;
    estado: string | null;
    cant_horas: number | null;
    fecha: string | null;
    tipo_lavado: string | null;
  }[];
  opinion_cliente: { contacto?: string; comentario?: string };
  stock: {
    id: number;
    codigo: string;
    descripcion: string;
    cantidad_stock: number | null;
    cantidad_sugerida: number | null;
    porcentaje: number | null;
  }[];
  comentarios: Record<'personal' | 'deposito' | 'maquinas' | 'limpieza' | 'stock' | 'otros', string[]>;
}

export const fetchHistorialFiscalizaciones = async (ps_id: number): Promise<{ datos: IHistorialFiscalizacion[], error?: string }> => {
  try {
    const response = await api.get(`${API_URL_HISTORIAL}/${ps_id}`);
    return { datos: response.data?.datos ?? [] };
  } catch (error: any) {
    console.error('Error en fetchHistorialFiscalizaciones:', error);
    return {
      datos: [],
      error: error?.response?.data?.error || 'Error al obtener el historial de fiscalizaciones',
    };
  }
}

export const fetchDetalleHistorialFiscalizacion = async (fis_id: number): Promise<{ datos?: IDetalleHistorialFiscalizacion, error?: string }> => {
  try {
    const response = await api.get(`${API_URL_HISTORIAL}/detalle/${fis_id}`);
    return { datos: response.data?.datos };
  } catch (error: any) {
    console.error('Error en fetchDetalleHistorialFiscalizacion:', error);
    return {
      error: error?.response?.data?.error || 'Error al obtener el detalle de la fiscalización',
    };
  }
}
